import { z } from 'zod';
import { amountSchema } from '../common/amount.js';
import { paginationMetaSchema } from '../common/pagination.js';
import { branchRefSchema } from '../common/refs.js';
import { exportLocaleShape, ledgerRowSchema, pageQueryShape, periodIsOrdered, periodQueryShape, PERIOD_ORDER_ISSUE, } from './common.js';
/** لمحة عامة (debts.md section 5). */
export const overviewQuerySchema = z
    .object({ ...periodQueryShape })
    .refine(periodIsOrdered, PERIOD_ORDER_ISSUE);
/**
 * The five legacy figures: عدد عملاء الذمم (debtors with an account that is
 * not deleted; one with accounts in two branches counts once overall and once
 * on each branch line)، إجمالي المبلغ المدين (balances > 0)، إجمالي المبلغ
 * الدائن (balances < 0, negative)، and the مدين / دائن movements of today or
 * of the chosen period.
 */
export const overviewFiguresSchema = z.object({
    debtors: z.number().int().nonnegative(),
    totalDebit: amountSchema,
    totalCredit: amountSchema,
    periodDebit: amountSchema,
    periodCredit: amountSchema,
});
export const overviewSchema = z.object({
    /** The chosen period; null means today (the "today" cards). */
    period: z.object({ from: z.string().nullable(), to: z.string().nullable() }).nullable(),
    /** The Asia/Amman day the "today" cards cover. */
    today: z.string(),
    branches: z.array(z.object({ branch: branchRefSchema, figures: overviewFiguresSchema })),
    totals: overviewFiguresSchema,
});
/** آخر الحركات: the last 24 hours, or the chosen period, newest first. */
export const latestMovementsQuerySchema = z
    .object({ ...periodQueryShape, ...pageQueryShape })
    .refine(periodIsOrdered, PERIOD_ORDER_ISSUE);
export const latestMovementsExportQuerySchema = z
    .object({ ...periodQueryShape, ...exportLocaleShape, format: z.literal('xlsx').default('xlsx') })
    .refine(periodIsOrdered, PERIOD_ORDER_ISSUE);
export const latestMovementsSchema = z.object({
    items: z.array(ledgerRowSchema),
    meta: paginationMetaSchema,
});
//# sourceMappingURL=overview.js.map